export default __webpack_public_path__ + "static/media/person-icon.b6ebcd43.png";